/**
 * Cart Dropdown Functionality
 */
(function($) {
  'use strict';

  $(document).ready(function() {
    const $cartButton = $('#cart-button');
    const $cartDropdown = $('#cart-dropdown');
    const $cartItemsContainer = $('#cart-dropdown-items');
    const $cartBadge = $('#cart-badge');
    
    if (!$cartButton.length || !$cartDropdown.length) {
      console.error('Cart elements not found');
      return;
    }
    
    let previousCartCount = 0;
    
    // Toggle cart dropdown on cart icon click
    $cartButton.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if ($cartDropdown.hasClass('is-visible')) {
        $cartDropdown.removeClass('is-visible');
      } else {
        updateCartDropdown();
        $cartDropdown.addClass('is-visible');
      }
    });
    
    // Close dropdown when clicking outside
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.c-cart__container').length) {
        $cartDropdown.removeClass('is-visible');
      }
    });
    
    // Function to update cart dropdown contents
    function updateCartDropdown() {
      // Show loading state
      $cartItemsContainer.html('<p>Loading cart...</p>');
      
      // Custom AJAX request to get cart data directly from WooCommerce
      $.ajax({
        url: window.location.origin + '/wp-admin/admin-ajax.php',
        type: 'POST',
        data: {
          action: 'get_cart_contents_custom'
        },
        success: function(data) {
          console.log('Cart data received:', data);
          
          // Clear current items
          $cartItemsContainer.empty();
          
          // Update cart badge with item count
          let totalItems = 0;
          
          // Check if we have items
          if (data && data.items && data.items.length > 0) {
            // Count total items
            data.items.forEach(function(item) {
              totalItems += parseInt(item.quantity);
            });
            
            // Add items to dropdown
            data.items.forEach(function(item) {
              const $cartItem = $('<div class="c-cart__dropdown__item"></div>');
              $cartItem.html(`
                <div class="c-cart__dropdown__item-details">
                  <p class="c-cart__dropdown__item-name">${item.name}</p>
                  <p class="c-cart__dropdown__item-quantity">Qty: ${item.quantity}</p>
                </div>
              `);
              
              $cartItemsContainer.append($cartItem);
              
              // Apply fade-in animation
              setTimeout(function() {
                $cartItem.css('animation', 'fadeIn 0.5s ease');
              }, 10);
            });
          } else {
            // Empty cart message
            $cartItemsContainer.html('<p>Your cart is empty</p>');
          }
          
          // Update badge
          $cartBadge.text(totalItems);
          
          // Show/hide badge based on count
          if (totalItems > 0) {
            $cartBadge.show();
            
            // Add pulse animation if count changed
            if (totalItems !== previousCartCount) {
              $cartBadge.addClass('pulse');
              setTimeout(function() {
                $cartBadge.removeClass('pulse');
              }, 500);
            }
          } else {
            $cartBadge.hide();
          }
          
          // Update previous count
          previousCartCount = totalItems;
        },
        error: function(error) {
          console.error('Error fetching cart data:', error);
          $cartItemsContainer.html('<p>Unable to load cart</p>');
        }
      });
    }
    
    // Function to check URL parameters
    function getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      const results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
    
    // Check if cart should be opened based on URL parameter
    function checkOpenCartFromUrl() {
      const openCart = getUrlParameter('open');
      const addToCart = getUrlParameter('add-to-cart');
      
      if (openCart === '1' || (addToCart && openCart === '1')) {
        // Wait a moment for the cart to be updated with the new product
        setTimeout(function() {
          updateCartDropdown();
          $cartDropdown.addClass('is-visible');
        }, 1000);
      }
    }
    
    // Listen for cart updates (WooCommerce events)
    $(document.body).on('added_to_cart removed_from_cart updated_cart_totals', function() {
      updateCartDropdown();
      $cartDropdown.addClass('is-visible');
    });
    
    // Check for URL parameters on page load
    checkOpenCartFromUrl();
    
    // Initialize cart badge on page load
    updateCartDropdown();
    
    // Set up periodic cart updates to keep badge in sync
    setInterval(updateCartDropdown, 30000); // Check every 30 seconds
  });
  
})(jQuery);
